<div class="flex flex-row p-4 mb-4 bg-red-500 rounded">
  <div class="flex items-center mr-4">
    <!-- <mat-icon class="text-red-900 transform scale-150">done</mat-icon> -->
  </div>
  <ng-content></ng-content>
</div>
